import React from 'react';
import { AppContext } from './AppContext';
import { Outlet } from 'react-router-dom';
import { Footer } from '../Footer';
import { Navbar } from '../navbar/Navbar';
import { CookeiNotice } from './CookieNotice';
import { AuthService } from '../services/AuthService';

export const PageLayout = (props: {
  footer: boolean;
}) => {

  const setStatus = (status: string | undefined) => {
    const elem = document.getElementById('eitum-status');
    if (elem) {
      elem.style.display = status ? 'inline-block' : 'none';
      if (elem.lastChild)
        elem.lastChild.textContent = status ?? '';
    }
  }

  const [isAuthenticated, setIsAuthenticated] = React.useState<boolean | undefined>(undefined);

  const updateIsAuthenticated = () => {
      if (typeof AuthService.account !== 'undefined') {
        if (AuthService.account) {
        AuthService.getAccessToken().then(() => {
          setIsAuthenticated(true);
          updateRoles([]);
        }).catch(() => {
          setIsAuthenticated(false);
        });
      } else {
        setIsAuthenticated(false);
      }
    }
  }

  React.useEffect(() => {
    AuthService.configure(updateIsAuthenticated).then(() => {
      updateIsAuthenticated();
    });
  }, []);

  const [roles, setRoles] = React.useState<string[]>([]);

  const updateRoles = (roles: string[]) => {
    const result: string[] = [];
    if (AuthService.isAdmin) {
      result.push('admin');
    }
    else if (AuthService.isStaff) {
      result.push('staff');
    }
    result.push(...roles);
    setRoles(result);
  }
  
 return (
    <AppContext.Provider value={{ setStatus, isAuthenticated, roles, updateRoles }}>
      <Navbar />
      <Outlet />
      {props.footer && <Footer />}
      <CookeiNotice />
    </AppContext.Provider>
  );
}